import { Component, HostListener } from '@angular/core';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

@Component({
  selector: 'app-home-four',
  templateUrl: './home-four.component.html',
  styleUrl: './home-four.component.css'
})
export class HomeFourComponent {
  //header
  lastScrollTop = 0;
  isHidden = false;
  isMenuOpen = false;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }


  @HostListener('window:scroll', [])
  onScroll(): void {

    const skillsSection = document.querySelector('.skill');
    
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    // Check scroll direction
    if (currentScroll > this.lastScrollTop && currentScroll > 100) {
      // Scrolling down
      this.isHidden = true;
    } else {
      // Scrolling up
      this.isHidden = false;
    }

    this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; 
  }

  // ScrollToSection
  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      const yOffset = -80; 
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  // Skills
  skills = [
    { name: 'Branding', level: 94 },
    { name: 'Social Marketing', level: 89 },
    { name: 'Copy Writing', level: 90 },
    { name: 'Consulting', level: 70 }
  ];

  isScrolled = false;

  // Funfacts
  funFacts =[
    {
      number: 14,
      desc: "Years of experience",
      displayedNumber: 0
    },
    {
      number: 100,
      desc: "Statisfy Clients",
      displayedNumber: 0
    },
    {
      number: 500,
      desc: "Projects Won",
      displayedNumber: 0
    }
  ]

  ngOnInit(): void {
    this.startCounters();
  }

  startCounters(): void {
    this.funFacts.forEach(fact => {
      this.animateCounter(fact);
    });
  }

  animateCounter(fact: any): void {
    const duration = 4000; 
    const intervalTime = 50; 
    const increment = fact.number / (duration / intervalTime);

    const interval = setInterval(() => {
      fact.displayedNumber += increment;
      if (fact.displayedNumber >= fact.number) {
        fact.displayedNumber = fact.number;
        clearInterval(interval); 
      }
    }, intervalTime);
  }

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // Portfolio Items
  portfolioItems = [
    {
      title: 'Red Record Disk',
      category: 'Creative',
      categoryClass: 'category-creative',
      image: 'assets/images/portfolio/gallery-1.jpg'
    },
    {
      title: 'Mobile App',
      category: 'Branding',
      categoryClass: 'category-branding',
      image: 'assets/images/portfolio/gallery-2.jpg'
    },
    {
      title: 'Pink Mockup',
      category: 'Creative',
      categoryClass: 'category-creative',
      image: 'assets/images/portfolio/gallery-3.jpg'
    },
    {
      title: 'Product Design',
      category: 'Branding',
      categoryClass: 'category-branding',
      image: 'assets/images/portfolio/gallery-5.jpg'
    }
  ];

  //Resume 
  resumeItems = [
    {
      title: 'UI/UX Designer at Envato',
      description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.`,
      date: '2024 - Present'
    },
    {
      title: 'Project Lead at Envato',
      description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.`,
      date: '2022 - 2023'
    },
    {
      title: 'Angular Developer at Envato',
      description: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem.`,
      date: '2020 - 2022'
    }
  ];
  clients = [
    { img: 'assets/images/brands/brand-1.png', alt: 'brand-1', link: '/' },
    { img: 'assets/images/brands/brand-2.png', alt: 'brand-2', link: '/' },
    { img: 'assets/images/brands/brand-3.png', alt: 'brand-3', link: '/' },
    { img: 'assets/images/brands/brand-4.png', alt: 'brand-4', link: '/' },
    { img: 'assets/images/brands/brand-5.png', alt: 'brand-5', link: '/' },
    { img: 'assets/images/brands/brand-6.png', alt: 'brand-6', link: '/' }
  ];

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'helifax-form';  // Replace with your EmailJS Service ID
  private templateId = 'helifax-form';  // Replace with your EmailJS Template ID
  private publicKey = 'dOfh1ImCGDZCO9GJb';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }
}
